// extracted by mini-css-extract-plugin
export default {"marketplaceMenuSA":"_84e98s","marketplaceMenuSa":"_84e98s","marketplaceMenu":"_170xv26","search-menu":"_ima1so","searchMenu":"_ima1so"};